export default class Permission {
  setControls(path) {
    let status;
    if (localStorage.getItem("efaa_dash_User_Type") != "superadmin") {
      if (localStorage.getItem("efaa_dash_controls")) {
        let controls = JSON.parse(localStorage.getItem("efaa_dash_controls"));
        const found = controls.find((control) => control.url == path);

        if (found) {
          status = false;
        } else {
          status = true;
        }
      }
    } else {
      status = false;
    }
    return status;
  }
  allowed(path) {
    let status;
    if (localStorage.getItem("efaa_dash_User_Type") != "superadmin") {
      if (localStorage.getItem("efaa_dash_permissions")) {
        let controls = localStorage.getItem("efaa_dash_permissions").split(",");
        console.log(path);
        console.log(controls);

        const found = controls.find((control) => control == path);
        console.log(found);
        if (found) {
          status = false;
        } else {
          status = true;
        }
      }
    } else {
      status = false;
    }
    return status;
  }
}
